/**
* Created by bieao on 2020/4/2.
*/
<template>
    <div class="item-position statistics-today">
      <div class="title-item">
        <div class="first"></div>
        <div class="two">03</div>
        <div class="title">
          <div>Distribution Box Data</div>
          <div>配电箱数据(24H)</div>
        </div>
      </div>
      <div class="statistics-item current-item m-b-20 m-t-10">
        <div class="statistics-title">
          <span class="m-r-20">配电箱</span>
          <span class="box-name">{{data.name}}</span>
        </div>
      </div>
      <div class="statistics-item">
        <div class="statistics-title m-r-30">
          额定值
        </div>
        <div>
          <div class="statistics-rate  m-b-5">
            <span class="m-r-10">电流</span>
            <span class="rate">{{data.ratedCurrent}}&nbsp;&nbsp;&nbsp;&nbsp;A</span>
          </div>
          <div class="statistics-rate">
            <span class="m-r-10">温度</span>
            <span class="rate">{{data.ratedTemperature}}&nbsp;&nbsp;&nbsp;&nbsp;℃</span>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'BoxInformation',
  props: {
    data: {
      type: Object
    }
  }
}
</script>

<style scoped lang="scss">
  .statistics-today{
    left: 1640px;
    top: 11px;
    .current-item{
      height:70px !important;
      .statistics-title{
        font-size: 18px !important;
      }
      .box-name {
        color:#49d5f3;
      }
    }
    .statistics-item{
      width:250px;
      height:70px;
      background: url('/static/img/item-bg300x70.png') center center no-repeat;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      padding:0 20px;
      .statistics-title{
        font-size: 15px;
      }
      .statistics-rate{
        font-size: 13px;
        .rate{
          color:#49d5f3;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/BoxInformation.vue